import { render, staticRenderFns } from "./CompanyInfoInvoices.vue?vue&type=template&id=b0c0ae82&"
import script from "./CompanyInfoInvoices.vue?vue&type=script&lang=ts&"
export * from "./CompanyInfoInvoices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0c0ae82')) {
      api.createRecord('b0c0ae82', component.options)
    } else {
      api.reload('b0c0ae82', component.options)
    }
    module.hot.accept("./CompanyInfoInvoices.vue?vue&type=template&id=b0c0ae82&", function () {
      api.rerender('b0c0ae82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyInfoInvoices.vue"
export default component.exports